import Styled from 'styled-components';

import {
  Card,
  CardContent,
  CardActions,
} from '@one-thd/sui-atomic-components';
import { desktop, tablet, mobile } from '../../utils/constants';

export const CustomCard = Styled(Card)`
display: block;
@media all and (max-width: 767px) and (min-width: ${desktop}) {
  display: block;
}
@media all and (max-width: 767px) and (min-width: ${mobile}) {
  height: 147px;
}
`;

export const CustomContent = Styled(CardContent)`
  height: 142px;
   padding: 0;

   @media all and (max-width: 767px) and (min-width: ${mobile}) {
    height: 113px;
   }
`;

export const CustomCardActions = Styled(CardActions)`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  top: 45px;

  @media all and (max-width: 767px) and (min-width: ${mobile}) {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    top: 15px;
    
  }
`;
